<template>
  <div class="d-flex flex-grow-1">
    <template v-if="icons">
      <v-btn
        v-if="buttons.includes('cart')"
        :loading="loading"
        small
        outlined
        color="primary"
        min-width="30px"
        class="pa-0 action-button"
        :title="mess['action_button_cart']"
        @click="addToCartHandler"
      >
        <v-icon size="20">
          mdi-cart-plus
        </v-icon>
      </v-btn>
      <v-btn
        v-if="buttons.includes('wishlist')"
        small
        outlined
        color="primary"
        min-width="30px"
        class="pa-0 action-button"
        :title="mess['action_button_wishlist']"
        @click="$emit('open-wishlist-dialog', item)"
      >
        <v-icon size="22">
          mdi-star-outline
        </v-icon>
      </v-btn>
    </template>
    <template v-if="!icons">
      <v-btn
        v-if="buttons.includes('cart')"
        :disabled="loading"
        @click="addToCartHandler"
        outlined
        color="primary"
        class="action-button-text mr-1 flex-grow-1"
        >{{ mess["e_detail_add_to_cart"] }}</v-btn
      >
      <v-btn
        v-if="buttons.includes('wishlist')"
        :disabled="loading"
        @click="$emit('open-wishlist-dialog', item)"
        outlined
        class="action-button-text action-button-text--gray flex-grow-1"
        >{{ mess["e_detail_add_to_wish_list"] }}</v-btn
      >
    </template>
    <v-btn
      v-if="buttons.includes('edit')"
      small
      outlined
      color="primary"
      min-width="30px"
      class="pa-0 action-button"
      :title="mess['action_button_edit']"
      @click="$emit('open-edit-dialog', item)"
    >
      <v-icon size="22">
        mdi-pencil-outline
      </v-icon>
    </v-btn>
    <v-btn
      v-if="buttons.includes('submit')"
      small
      outlined
      color="primary"
      min-width="30px"
      class="pa-0 action-button"
      title="Редактировать"
      @click="$emit('submit', item)"
    >
      <v-icon size="22">
        mdi-check-outline
      </v-icon>
    </v-btn>
    <v-btn
      v-if="buttons.includes('remove')"
      small
      outlined
      color="primary"
      min-width="30px"
      class="pa-0 action-button"
      :title="mess['action_button_remove']"
      @click="$emit('remove', item)"
    >
      <v-icon size="22">
        mdi-close
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
// Services
import { cartService } from "@/services/cart-service/cart-service";

// Models
import notifications from "@/models/notificationTemplates";

export default {
  name: "ActionButtons",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    buttons: {
      type: Array,
      default: () => ["cart", "wishlist"]
    },
    icons: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    addToCartHandler(event, options = {}) {
      this.loading = true;

      cartService
        .addToCart(this.item, options)
        .then(response => {
          if (response.success) {
            this.$emit("added-to-cart", notifications.success.addToCart);
            this.$emit("change-cart-items", {
              quantityString: response.items_text,
              quantity: response.items_count
            });
          } else {
            this.$emit("added-to-cart", notifications.error.base);
            throw new Error("Server error");
          }
        })
        .catch(err => {
          this.$emit("added-to-cart", notifications.error.base);
          throw new Error(err);
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss">
.action-button {
  border: none;
}

.action-button:not(:last-of-type) {
  margin-right: 4px;
}

.v-btn.action-button-text {
  font-size: 12px;
  font-weight: 700;
  height: 27px !important;
  min-height: 27px;
  padding: 0 6px;
}

.v-btn.action-button-text--gray {
  color: gray;
}

.b-spinner__button {
  width: auto !important;
  flex-grow: 1 !important;
}

.action-button-tooltip.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
  background: #ffffff;
  color: #000000;
  border: 2px solid var(--v-primary-base);
}

.action-button-tooltip.v-tooltip__content {
  p {
    padding: 0;
    margin: 0;
  }
}
</style>
